<template>
  <div>
    <v-list density="compact" nav>
      <!-- Home -->
      <v-list-item
        prepend-icon="mdi-home"
        title="Home"
        value="/"
        @click="$router.push('/')"
      />

      <!-- Dynamic items -->
      <v-list-item
        v-for="item in menu"
        :key="item.to"
        :value="item.to"
        :prepend-icon="item.icon"
        :title="item.title"
        @click="$router.push(item.to)"
        :class="item.colorClass"
      />
    </v-list>
  </div>
</template>

<script>
import { menuItems } from '@/config/menuItems'

export default {
  name: 'MenueBar',

  data () {
    return {
      menu: []
    }
  },

  created () {
    this.updateMenu()
  },

  methods: {
    updateMenu () {
      const seenRoutes = new Set()
      const out = []

      for (const item of menuItems) {
        const { icon, to, title, enabled, type } = item

        // your existing rule
        if (title === 'MasterData' && sessionStorage.getItem('BilderID') === null) {
          continue
        }

        // Option 1: route must be unique
        if (seenRoutes.has(to)) {
          console.warn('Duplicate route in menu:', to, item)
          continue
        }
        seenRoutes.add(to)

        // map type -> color class (Vuetify utility classes)
        let colorClass = ''
        if (type === 'finance') colorClass = 'text-green-lighten-1'
        else if (type === 'sport') colorClass = 'text-orange-lighten-1'
        else if (type === 'test') colorClass = 'text-yellow'

        // if you want to hide disabled items:
        if (enabled === false) continue

        out.push({ icon, to, title, type, colorClass })
      }

      this.menu = out
    }
  }
}
</script>
